import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db, auth } from "../firebase";
import achievementsData from "../data/achievementsData";

export default function AchievementsPanel() {
  const [achievements, setAchievements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAchievements = async () => {
      try {
        const user = auth.currentUser;
        if (!user) return;

        const colRef = collection(db, "Users", user.uid, "Achievements");
        const snapshot = await getDocs(colRef);

        const list = snapshot.docs.map(doc => {
          const data = doc.data();
          const normalizedId = doc.id.toLowerCase();
          const def = achievementsData[normalizedId] || {};

          let status;
          let isClaimed = false;

          if (data.achieved === "false") {
            status = "LOCKED";
          } else if (typeof data.achieved === "number") {
            isClaimed = true;
            const date = new Date(data.achieved);
            status = date.toLocaleDateString("en-US", {
              year: "2-digit",
              month: "2-digit",
              day: "2-digit",
            });
          } else {
            status = "UNKNOWN";
          }

          return {
            id: normalizedId,
            num: parseInt(normalizedId.replace(/\D/g, ""), 10),
            name: def.name || doc.id,
            description: def.description || "No description available.",
            status,
            isClaimed
          };
        }).sort((a, b) => a.num - b.num);

        setAchievements(list);
      } catch (err) {
        console.error("Error fetching achievements:", err);
      }
      setLoading(false);
    };

    fetchAchievements();
  }, []);

  if (loading) return (
    <div style={{ padding: "20px", color: "#50e3c2", fontFamily: "'JetBrains Mono', monospace" }}>
      LOADING...
    </div>
  );

  return (
    <div style={{ 
      padding: "10px", 
      fontFamily: "'JetBrains Mono', monospace",
      backgroundColor: "rgba(0, 20, 20, 0.4)",
      border: "1px solid rgba(80, 227, 194, 0.1)",
      borderRadius: "4px"
    }}>

      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        {achievements.map(ach => (
          <div 
            key={ach.id}
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 2fr 100px",
              alignItems: "center",
              padding: "12px",
              background: ach.isClaimed ? "rgba(80, 227, 194, 0.05)" : "rgba(255, 255, 255, 0.02)",
              borderLeft: `3px solid ${ach.isClaimed ? "#50e3c2" : "#333"}`,
              transition: "all 0.2s ease"
            }}
          >
            {/* Name */}
            <div style={{ 
              color: ach.isClaimed ? "#50e3c2" : "#666", 
              fontSize: "0.85rem", 
              fontWeight: "bold",
              textTransform: "uppercase"
            }}>
              {ach.name}
            </div>

            {/* Description */}
            <div style={{ 
              color: ach.isClaimed ? "#eee" : "#555", 
              fontSize: "0.75rem",
              paddingRight: "10px"
            }}>
              {ach.description}
            </div>

            {/* Status / Date */}
            <div style={{ 
              textAlign: "right", 
              fontSize: "0.65rem",
              color: ach.isClaimed ? "#50e3c2" : "#444",
              letterSpacing: "1px"
            }}>
              {ach.isClaimed && <span style={{ fontSize: '0.5rem', display: 'block' }}>COMPLETED</span>}
              {ach.status}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}